import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './themes/default';
import { GridOverlayProvider } from './context/use-grid-overlay';
import { ForegroundApp } from './presentation/forground-app';
import { AuthProvider } from './context/use-app-auth';
import { SettingsProvider } from './presentation/settings/settings-context';
import { SubscriptionProvider } from './context/subscription-context';

const App: React.FC = () => {
  return (
    <GridOverlayProvider>
      <ThemeProvider theme={theme}>
        <AuthProvider>
          <SubscriptionProvider>
            <SettingsProvider>
              <ForegroundApp />
            </SettingsProvider>
          </SubscriptionProvider>
        </AuthProvider>
      </ThemeProvider>
    </GridOverlayProvider>
  );
};
export default App;
